var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 12.6667C6.5109 12.667 6.35994 12.6127 6.24 12.5133C6.10366 12.4003 6.0179 12.2377 6.00164 12.0613C5.98538 11.885 6.03996 11.7094 6.15333 11.5733L9.14 8L6.26 4.42C6.14815 4.28227 6.09582 4.10564 6.11459 3.92922C6.13336 3.75279 6.22168 3.59112 6.36 3.48C6.49944 3.35731 6.68375 3.29835 6.86852 3.31734C7.05328 3.33632 7.22175 3.43152 7.33333 3.58L10.5533 7.58C10.7555 7.826 10.7555 8.18067 10.5533 8.42667L7.22 12.4267C7.08436 12.5903 6.87882 12.6794 6.66667 12.6667Z",
    fill: "#919EAB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnNext);
export default __webpack_public_path__ + "static/media/btn-next.e25f86480e2ad7f5ee69346d1cf190a3.svg";
export { ForwardRef as ReactComponent };